export default class OrderShippingLabel {

  static CARRIER_OTHER = 1;
  static CARRIER_FEDEX = 2;
  static CARRIER_UPS = 3;

}